// extracted by mini-css-extract-plugin
export default {"wrapper":"Deg2D","description":"drqDO","number":"XUz5i","title":"GngZQ"};